import { ReactComponent as ArrowForwardSvg } from '../../assets/icons/arrow-forward.svg';

export const ArrowForwardIcon: SvgIcon = (props) => {
    return <ArrowForwardSvg {...props} />;
};
